import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import {  Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

function PartnerInfo() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();

  const partnerFromState = location.state?.partner;

  if (!partnerFromState) {
    return <p>No partner data available</p>;
  }

  return (
    <div className='container my-5'>
      <div className='row d-flex justify-content-center mb-4'>
        <div className='col-12 d-flex justify-content-center align-items-center'>
          <h3 className='underline'>
            {partnerFromState.partnerName || 'About Us'}
          </h3>
        </div>

        <div className='col-md-6 col-sm-12 d-flex justify-content-start'>
          <img
            src={partnerFromState.images[0]?.image || ''}
            alt={partnerFromState.partnerName || 'About Us'}
            style={{ width: '100%', height: 'auto', padding: '10px' }}
          />
        </div>

        <div className='col-md-6 col-sm-12 mt-4 d-flex'>
          <div className='row'>
            <div className='col-md-12'>
            <p style={{ textAlign: 'justify' }}>
            {partnerFromState.description || 'No description available.'}
          </p>
            </div>
            <div className='col-md-12 d-flex p-2'>
            <div className="d-flex justify-content-center align-items-end">
            <a href={partnerFromState.urlLink} target="_blank" rel="noopener noreferrer" style={{ width: '100%', textDecoration: 'none' }}>
              <Button
              variant="contained"
                // sx={{
                //   // color: 'var(--primary-color)',
                //   padding: '3px',
                // }}
                fullWidth
                color="success"
                endIcon={<OpenInNewIcon/>}
              >
                
                View More Details
              </Button>
            </a>
          </div>
            </div>
          </div>
          

        
        </div>
      </div>
    </div>
  );
}

export default PartnerInfo;
